import { pdfjsWorker } from "pdfjs-dist/build/pdf.worker.entry";
export default pdfjsWorker;